<div class="px-1 py-2 surface-ground md:px-1 lg:px-2">
  <block-ui>
    <div *ngIf="this.iAmLoading">
      <h2>Getting your information ....</h2>
    </div>
    <div *ngIf="!this.iAmLoading">
      <section class="px-6 py-1 surface-section">
        <header
          class="flex w-full p-4 pb-5 m-4 text-primary-500 justify-content-between align-items-center border-bottom-1 surface-border">
          <div>
            <h2 class="mt-0 mb-3 text-2xl font-medium text-500">
              Invoices
            </h2>
            <p class="mt-0 mb-0 text-base font-normal text-500">
              View and download your invoices in PDF format.
            </p>
          </div>
        </header>
        <div *ngIf="invoices() === undefined">
          <h2>No invoices found</h2>
        </div>
        <div *ngIf="invoices()">
          <app-most-recent-invoice class="m-4" [latest_invoice]="latest_invoice"></app-most-recent-invoice>
          <app-invoice-history  class="m-4" [invoices]="invoices"></app-invoice-history>
        </div>
        </section>
      </div>
      </block-ui> 
      </div>
